import React, { FormEvent, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  Container,
  Grid,
  Paper,
  Box,
  Button,
  Select,
  SelectChangeEvent,
  MenuItem,
  TextField,
  InputAdornment, IconButton
} from "@mui/material";
import Layout from "../Layout";
import { fetchRequest as fetchUser } from "../../store/user/actions";
import { ApplicationState } from "../../store";
import UserTable from "./userTable/UserTable";
import PageHeading from "../../common/pageHeading/PageHeading";
import ProgressIndicator from "../../common/progressIndicator/ProgressIndicator";
import useSession from "../../effects/useSession";
import pageStyles from "../pageStyles";
import { fetchRequest as fetchUserGroup } from "../../store/usergroup/actions";
import { MRT_PaginationState } from "material-react-table";
import FilterForm, { Entity, FilterDataParams, FilterFormProps } from "../../common/advancedFilter/AdvancedFilter";
import { FormikValues } from "formik";
import { ColumnToRecordMapping, TerminalTableParams } from "../terminal/terminalTable/TerminalTable";
import { fetchRequest } from "../../store/terminal/actions";
import CustomizedTooltip from "../../common/toolTip/CustomizedTooltip";
import { showBulkUpdateButtonTooltip } from "../../common/bulkUpdate/bulkUpdateHelper";
import { Search } from "@mui/icons-material";
import { Option } from "../../common/advancedFilter/DynamicField";

export default function User() {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = pageStyles();
  const session = useSession();
  let searchValue = "";
  let searchField = "email";
  const [ filterQuery, setFilterQuery ] = useState<FormikValues>({
    filter: {
      fieldName: searchField,
      value: searchValue
    }
  });

  const [ pagination, setPagination ] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });
  useEffect(() => {
    console.log("query changed filterQuery", filterQuery);
    console.log("query changed pagination", pagination);
    const params = {
      page: pagination.pageIndex,
      pageSize: pagination.pageSize,
      filter: filterQuery.filter
    };
    console.log('params', params)
    dispatch(fetchUser(null, params));
  }, [ filterQuery, pagination ]);

  useEffect(() => {
    dispatch(fetchUserGroup(null));
  }, []);

  const { loading, data } = useSelector(
    (state: ApplicationState) => state.user
  );
  const user = data?.data || [];
  const totalUser = data?.meta?.totalObjects ?? 0;

  const handleSearchAction = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFilterQuery({
      page: 0,
      pageSize: 20,
      filter: {
        fieldName: searchField,
        value: searchValue
      }
    });
    // dispatch(fetchRequest(null, filterQuery));
  };
  const handleOnChange = (event: { target: { value: string } }) => {
    console.log("handleOnChange", event.target.value);
    searchValue = event.target.value;
  };
  return (
    <Layout sessionData={session}>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Paper>
                <PageHeading
                  entity="User"
                  heading="Users"
                  primaryButtonText="Add New User"
                  primaryButtonClickHandler={() => history.push("/user/new")}
                />
              </Paper>
              <Box my={2}>
                <Paper>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    padding="2rem 1rem"
                  >
                    <Box
                      display="flex"
                      justifyContent="end"
                      alignItems="center"
                      width="100%"
                    >
                      <form
                        style={{ display: "flex" }}
                        onSubmit={(e) => handleSearchAction(e)}
                      >
                        {/*<Select*/}
                        {/*  value={searchField}*/}
                        {/*  onChange={(*/}
                        {/*    event: SelectChangeEvent<string>*/}
                        {/*  ) => {*/}
                        {/*    searchField = event.target.value as string;*/}
                        {/*  }}*/}
                        {/*>*/}

                        {/*  <MenuItem value="email">*/}
                        {/*    Email*/}
                        {/*  </MenuItem>*/}
                        {/*</Select>*/}
                        <TextField
                          style={{ marginLeft: 5, width: "200px" }}
                          placeholder={"Search"}
                          onChange={handleOnChange}
                          variant="standard"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  type="submit"
                                  edge="end"
                                >
                                  <Search />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </form>
                    </Box>
                  </Box>

                  {loading ? <ProgressIndicator /> :
                    <UserTable
                      user={user}
                      totalUsers={totalUser}
                      page={filterQuery.page}
                      pagination={pagination}
                      pageSize={filterQuery.pageSize}
                      onPageChanged={setPagination} />}
                </Paper>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </main>
    </Layout>
  );
}
